import '../i18n';
import {useTranslation} from 'react-i18next';
import React from 'react';
import { Link } from 'react-router-dom';
import { GREEN, PALE_WHITE_6, PRIMARY_COLOR, WHITE } from '../appearance/Colors';
import { clearPostLogoutRedirect } from '../util/logoutRedirect';

function AccountDeleted() {
    const {t: lnT} = useTranslation();

    React.useEffect(() => {
        clearPostLogoutRedirect();
    }, []);

    return (
        <div
            style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'linear-gradient(180deg, #16191b 0%, #23272a 100%)',
                padding: 24
            }}
        >
                <div
                    style={{
                        width: '100%',
                        maxWidth: 640,
                        backgroundColor: PRIMARY_COLOR,
                        borderRadius: 18,
                        padding: '48px 40px',
                        border: '1px solid rgba(255,255,255,0.08)'
                    }}
                >
                <div
                    style={{
                        width: 56,
                        height: 56,
                        borderRadius: 999,
                        backgroundColor: 'rgba(0,137,111,.16)',
                        color: GREEN,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 28,
                        fontWeight: 700,
                        marginBottom: 24
                    }}
                >
                    ✓
                </div>
                <h1 style={{ color: WHITE, fontSize: 32, lineHeight: 1.15, margin: 0 }}>{lnT('settings:yourAccountHasBeenDeleted')}</h1>
                <p style={{ color: PALE_WHITE_6, fontSize: 17, lineHeight: 1.6, margin: '18px 0 0 0' }}>{lnT('settings:theDeletionRequestCompletedSuccessfullyIfYou')}</p>

                <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginTop: 32 }}>
                    <Link
                        to="/"
                        style={{
                            backgroundColor: GREEN,
                            color: WHITE,
                            textDecoration: 'none',
                            padding: '12px 18px',
                            borderRadius: 10,
                            fontSize: 15,
                            fontWeight: 600
                        }}
                    >{lnT('settings:returnHome')}</Link>
                    <Link
                        to="/register"
                        style={{
                            backgroundColor: 'rgba(255,255,255,0.06)',
                            color: WHITE,
                            textDecoration: 'none',
                            padding: '12px 18px',
                            borderRadius: 10,
                            fontSize: 15,
                            fontWeight: 600,
                            border: '1px solid rgba(255,255,255,0.12)'
                        }}
                    >{lnT('settings:createNewAccount')}</Link>
                </div>
            </div>
        </div>
    );
}

export default AccountDeleted;
